import React from 'react';
import { observer } from 'mobx-react';
import { Field } from 'radiance-ui';

import { fieldIsValid } from 'jsx/utils/form/validations';
import { FormFieldType } from 'jsx/components/formHelper';

interface FieldWrapperProps {
  field: FormFieldType<string | boolean | null>;
  hideLabel?: boolean;
  hideErrorIcon?: boolean;
  disabled?: boolean;
}

const FieldWrapper: React.FC<FieldWrapperProps> = ({
  children,
  field,
  hideLabel = false,
  hideErrorIcon = false,
  disabled = false,
}) => {
  const { error, focused, id, label, touched } = field;
  const isValid = fieldIsValid(field);

  const displayValidation = touched && !focused;
  const labelText = hideLabel ? null : label;

  let errorProp = {};
  if (!isValid && displayValidation) {
    errorProp = { error };
  }

  return (
    <Field
      messages={errorProp}
      label={labelText as string | undefined}
      labelFor={id}
      hideMessagesIcon={hideErrorIcon}
      disabled={disabled}
    >
      {typeof children === 'function'
        ? children({ isValid, displayValidation })
        : children}
    </Field>
  );
};

export default observer(FieldWrapper);
